export const RecordTypes = {
  CONNECTION: "AF.ConnectionRecord",
  CREDENTIAL: "AF.CredentialRecord",
  PROOF: "AF.ProofRecord",
  MESSAGE: "WebAgent.BasicMessage",
};
